import { delogueApi, type ApiType } from 'lib/api';
import { stringParse } from 'utils';

export const apiBrandsDelogue: ApiType = {
  get: {
    list: ({ query }) => delogueApi.get('/api/brands/filter?state=active&pageSize=100', query),
    search: ({ query, vars }) =>
      delogueApi.get(
        stringParse('/api/brands/filter?state=active&search={0}&pageSize=100', vars),
        query
      ),
  },
  put: {},
  post: {},
  delete: {},
};
